import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-primary pt-16 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiHexagon} className="text-2xl text-accent" />
              <span className="font-heading font-bold text-xl tracking-wider">OBSIDIAN.</span>
            </Link>
            <p className="text-textMuted text-sm leading-relaxed">
              Montreal's premier auto detailing studio. Specializing in high-end paint correction, ceramic coatings, and transformative detailing services.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-textLight">Quick Links</h4>
            <ul className="space-y-2 text-sm text-textMuted">
              <li><Link to="/services" className="hover:text-accent transition-colors">Services</Link></li>
              <li><Link to="/packages" className="hover:text-accent transition-colors">Packages</Link></li>
              <li><Link to="/gallery" className="hover:text-accent transition-colors">Gallery</Link></li>
              <li><Link to="/booking" className="hover:text-accent transition-colors">Book Online</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-textLight">Contact</h4>
            <ul className="space-y-3 text-sm text-textMuted">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiIcons.FiMapPin} className="mt-1 text-accent flex-shrink-0" />
                <span>7350 Blvd Henri-Bourassa Ouest<br/>Montreal, QC H4S 1P9(demo)</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiIcons.FiPhone} className="text-accent flex-shrink-0" />
                <span>(514) 555-0157(demo)</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiIcons.FiMail} className="text-accent flex-shrink-0" />
                <span>hello@obsidianautospa.ca(demo)</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-textLight">Hours</h4>
            <ul className="space-y-2 text-sm text-textMuted">
              <li className="flex justify-between"><span>Mon - Fri</span><span>8:00 AM - 7:00 PM</span></li>
              <li className="flex justify-between"><span>Saturday</span><span>9:00 AM - 5:00 PM</span></li>
              <li className="flex justify-between text-accent"><span>Sunday</span><span>Closed</span></li>
            </ul>
            <div className="mt-6 flex gap-4">
              <a href="#" className="text-textMuted hover:text-accent transition-colors"><SafeIcon icon={FiIcons.FiInstagram} className="text-xl" /></a>
              <a href="#" className="text-textMuted hover:text-accent transition-colors"><SafeIcon icon={FiIcons.FiFacebook} className="text-xl" /></a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-textMuted">© {new Date().getFullYear()} Obsidian Auto Spa. All rights reserved. Site demo only.</p>
          <p className="text-xs text-textMuted">Designed for premium vehicles in Montreal, QC.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;